import uuidv4 from 'uuid/v4';
import { SELECT_INFO, REMOVE_INFO_SELECTION, CLEAR_INFO_SELECTIONS, UPDATE_DISPLAYED_INFOS } from '../mutation_types';
import { GET_INFOS_LIST } from '../action_types';
import { getFolders, searchGlobal } from '@/http/api';

const filesGenerator = (number) => {
    const fileObjs = [];
    for (let i = 1; i <= number; i++) {
        const fileObj = {
            type: 'image',
            title: `Info ${i} Címe`,
            date: `2016-12-1${i}`,
            uuid: uuidv4()
        }
        fileObjs.push(fileObj)
    }
    return fileObjs;
}

export const state = {
    selectedInfos: [],
    displayedInfos: []
};

export const getters = {
    getInfoSelectedState: (state) => (uuid) => {
        const ix = state.selectedInfos.findIndex(file => file.uuid === uuid)
        return ix > -1 ? true : false;
    }
};

export const mutations = {
    [SELECT_INFO](state, payload) {
        const newSelected = [...state.selectedInfos];
        if (newSelected.findIndex(infoObj => infoObj.uuid === payload.infoObj.uuid) === -1) {
            newSelected.push(payload.infoObj);
            state.selectedInfos = newSelected;
        }
    },
    [REMOVE_INFO_SELECTION](state, payload) {
        const newSelected = [...state.selectedInfos];
        newSelected.splice(newSelected.findIndex(file => file.uuid === payload.uuid), 1);
        state.selectedInfos = newSelected;
    },
    [CLEAR_INFO_SELECTIONS](state) {
        const newSelected = [];
        state.selectedInfos = newSelected;
    },
    [UPDATE_DISPLAYED_INFOS](state, payload) {
        const newDisplayed = payload.fileObjects;
        state.displayedInfos = newDisplayed;
    }
    

};

export const actions = {
    [GET_INFOS_LIST]({ commit }, payload) {
        return new Promise((resolve, reject) => {
            // const options = {
            //     params: {
            //         ...payload.options,
            //         isInfo: true
            //     }
                
            // }
            const options = payload.options
            console.log('INFOPTIONS', options);
            searchGlobal(options).then(res => {
                console.log('INFOZREZ', res);
                commit({
                    type: UPDATE_DISPLAYED_INFOS,
                    fileObjects: res.data.result
                })
                resolve(res);
            });
        })
    }
};

export default {
    state,
    getters,
    mutations,
    actions
}